interface UserState {
  id: string | undefined;
  name: string | undefined;
  email: string | undefined;
  avatar: string | undefined;
  title: string | undefined;
  dateFormat: string | undefined;
  currentOrganisation: string | undefined;
  role: { id: string; name: string } | undefined;
  mfaEnabled?: boolean;
  mfaBackupCodeCount?: number;
}

interface SetUserDetailsAction {
  type: "SET_USER_DETAILS";
  payload: {
    id: string;
    name: string;
    email: string;
    avatar: string;
    title: string;
    dateFormat: string;
    currentOrganisation: string;
    role: { id: string; name: string };
    mfaEnabled?: boolean;
    mfaBackupCodeCount?: number;
  };
}

const initialState: UserState = {
  id: "",
  name: "",
  email: "",
  title: "",
  dateFormat: "",
  avatar: "",
  currentOrganisation: "",
  role: { id: "", name: "" },
  mfaEnabled: false,
  mfaBackupCodeCount: 0,
};

const usersReducer = (
  state = initialState,
  action: SetUserDetailsAction | { type: "LOGOUT" }
): UserState => {
  switch (action.type) {
    case "SET_USER_DETAILS":
      return {
        ...state,
        id: action.payload?.id || "",
        name: action.payload?.name || "",
        email: action.payload?.email || "",
        title: action.payload?.title || "",
        dateFormat: action.payload?.dateFormat || "",
        avatar: action.payload?.avatar || "",
        currentOrganisation: action.payload?.currentOrganisation || "",
        role: action.payload?.role || { id: "", name: "" },
        mfaEnabled: action.payload?.mfaEnabled ?? false,
        mfaBackupCodeCount: action.payload?.mfaBackupCodeCount ?? 0,
      };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
};

export default usersReducer;
